import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext, useMemo } from 'react';
import { DeviceState } from './types';
import { useDeviceConfig } from '../config';
import { useSupportAccount } from 'console/shared/hooks/helpers';
import { useIsServiceMode } from 'console/shared/contexts/device/state/is-service-view-selector';
export const DeviceStateProvider = memo(function DeviceStateProvider(props) {
    const { online, icon_state, children } = props;
    const { device_id } = useDeviceConfig();
    const is_support = useSupportAccount();
    const is_service_mode = useIsServiceMode(device_id);
    const device_state_context = useMemo(() => ({
        is_service_mode: is_support ? true : is_service_mode,
        online,
        icon_state,
    }), [is_service_mode, online, icon_state]);
    return (_jsx(DeviceState.Provider, { value: device_state_context, children: children }));
});
export const useDeviceState = () => useContext(DeviceState);
